import i18n from 'translations';
import { config } from 'translations';
const { CULTURE_INFO, CULTURE_LANG } = config;

export { CULTURE_INFO, CULTURE_LANG };
export default i18n;
